<style>
    .ag-theme-material .ag-cell {
        line-height: 35px !important;
    }
</style>

<template>
  <div id="ag-grid-demo">
    <vx-card class="p-4 mb-6">
        <div class="flex flex-wrap items-center justify-between mb-10">
            <div class="flex items-center">
                <h4 style="margin-left: 10px">Return Delivery Order</h4>
            </div>
            <div class="flex items-center">
                <vs-button @click="refreshData" class="btn mb-4 md:mb-0 mr-1" icon="refresh">Refresh</vs-button>
                <vs-button class="btn mb-4 md:mb-0 mr-1" icon="add" @click="activeSearchDO = true">Add</vs-button>
                <vs-button @click="viewData" class="btn mb-4 md:mb-0 mr-1" icon="remove_red_eye" :disabled="!selectedId">View</vs-button>
                <vs-button @click="deleteData" class="btn mb-4 md:mb-0 mr-1" icon="delete" :disabled="!selectedId">Delete</vs-button>
                <vs-button class="mb-4 md:mb-0 mr-1" icon="filter_list" @click="filter.active = true">Filter</vs-button>
                <vs-button :to="{ name: 'wave-pick-planning-add'}" class="btn mb-4 md:mb-0 mr-1" icon="save_alt">Export</vs-button>
            </div>
        </div>
        <ag-grid-vue
            :gridOptions="gridOptions"
            class="ag-theme-material w-100 my-4 ag-grid-table"
            :columnDefs="columnDefs"
            :defaultColDef="defaultColDef"
            :rowData="rdo"
            colResizeDefault="shift"
            :animateRows="false"
            :floatingFilter="false"
            rowSelection="single"
            @rowDoubleClicked="viewData"
            @selection-changed="onSelectionChanged"
            >
        </ag-grid-vue>
        <p class="text-right"><b>Showing {{ dataFrom }} to {{ dataTo }} of {{ dataTotal }}  total entries</b></p>
        <vs-pagination :total="totalPage" v-model="currentPage" :max="7"></vs-pagination>
        <vs-prompt
            title="Filter"
            buttons-hidden
            :active.sync="filter.active">
            <div class="con-exemple-prompt">
                <vs-input label="RDO ID" v-model="filter.id" class="w-full" />
                <vs-input label="Reference" v-model="filter.reference" class="mt-2 w-full mb-2" />
                <label class="vs-input--label">Client ID</label>
                <vs-select
                    class="selectExample mb-2"
                    v-model="filter.client_id"
                    width="100%"
                    autocomplete
                    @input-change="searchDropdown($event, client)"
                >
                    <vs-select-item v-for="(item, index) in client.data" :key="index" :value="item.id" :text="item.client_code"/>
                </vs-select>
                <label class="vs-input--label">Origin ID</label>
                <vs-select
                    class="selectExample mb-2"
                    v-model="filter.origin_id"
                    width="100%"
                    autocomplete
                    @input-change="searchDropdown($event, customer)"
                >
                    <vs-select-item v-for="(item, index) in customer.data" :key="index" :value="item.id" :text="item.name"/>
                </vs-select>
                <label class="vs-input--label">Destination ID</label>
                <vs-select
                    class="selectExample mb-2"
                    v-model="filter.destination_id"
                    width="100%"
                    autocomplete
                    @input-change="searchDropdown($event, customer)"
                >
                    <vs-select-item v-for="(item, index) in customer.data" :key="index" :value="item.id" :text="item.name"/>
                </vs-select>
                <vs-input label="DO Reference" v-model="filter.do_reference" class="w-full mb-2" />
                <label class="vs-input--label">RDO Status</label>
                <vs-select
                    class="selectExample mb-2"
                    v-model="filter.rdo_status"
                    width="100%"
                    autocomplete
                    @input-change="searchDropdown($event, customer)"
                >
                    <vs-select-item value="" text="Any"/>
                    <vs-select-item value="Open" text="Open"/>
                    <vs-select-item value="1" text="Unreceived"/>
                    <vs-select-item value="7" text="Already Received"/>
                    <vs-select-item value="8" text="Partially Putaway"/>
                    <vs-select-item value="9" text="Closed - Fully Putaway"/>
                </vs-select>
                <vs-row
                    vs-align="flex-start"
                    vs-type="flex"
                    vs-justify="flex-end"
                    vs-w="12"
                    class="mt-5"
                >
                    <vs-button color="primary" type="flat" @click="resetFilter" class="mr-2">Reset</vs-button>
                    <vs-button color="primary" @click="filterData">Search</vs-button>
                </vs-row>
            </div>
        </vs-prompt>
        <vs-prompt
            @accept="searchDO"
            :active.sync="activeSearchDO"
            title="Search Delivery Order"
            >
            <div class="con-exemple-prompt">
                <div class="vx-col w-full">
                    <ul class="leftx">
                        <li>
                            <vs-radio v-model="data.withReference" vs-name="withReference" :vs-value="false">Without DO Reference</vs-radio>
                        </li>
                        <li>
                            <vs-radio v-model="data.withReference" vs-name="withReference" :vs-value="true">With DO Reference</vs-radio>
                        </li>
                    </ul>
                    <vs-divider border-style="solid" color="dark"></vs-divider>
                    <div class="vx-row mb-3">
                        <div class="vx-col w-1/3">
                            DO Reference*
                        </div>
                        <div class="vx-col w-2/3">
                            <vs-input class="w-full" :disabled="!data.withReference" v-model="data.do_reference" @keyup.enter="searchDO"/>
                        </div>
                    </div>
                    <div class="vx-row">
                        <div class="vx-col w-1/3">
                            Client*
                        </div>
                        <div class="vx-col w-2/3">
                            <v-select :options="clientOptions" v-model="data.client" label="client_code" :clearable="false" :disabled="!data.withReference"></v-select>
                        </div>
                    </div>
                </div>
                <vs-alert v-if="doSearchError" color="danger" vs-icon="new_releases" class="mt-5">
                    {{ doSearchError }}
                </vs-alert>
            </div>
        </vs-prompt>
    </vx-card>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue"
import '@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss'
import vSelect from 'vue-select'

export default {
    components: {
        vSelect,
        AgGridVue,
    },
    data() {
        return {
            gridOptions: {},
            gridApi: null,
            rdo: [],
            columnDefs: null,
            defaultColDef: {
                sortable: true,
                editable: false,
                resizable: true,
                suppressMenu: true
            },
            activeSearchDO: false,
            data: {
                withReference: false,
                do_reference: '',
                client: this.$store.state.user.userconfig.clients
            },
            doSearchError: '',
            selectedId: null,
            isLoading: false,
            clientOptions: this.$store.state.user.userconfig.client_options,
            totalPage: 0,
            currentPage: 1,
            dataFrom: 0,
            dataTo: 0,
            dataTotal: 0,
            filter: {
                reference: '',
                id: '',
                client_id: null,
                origin_id: null,
                destination_id: null,
                do_reference: '',
                rdo_status: 'Open',
                active: false,
            },
            client: {
                data: [],
                loading: false,
                endpoint: 'master/clients',
                objectKey: 'client_code'
            },
            customer: {
                data: [],
                loading: false,
                endpoint: 'master/customers',
                objectKey: 'name'
            },
        }
    },
    watch: {
        isLoading: function(){
            if(this.isLoading){
                this.$vs.loading()
            }
            else{
                this.$vs.loading.close()
            }
        },
        currentPage: function() {
            this.fetchData()
        }
    },
    methods: {
        onSelectionChanged() {
            var selectedRows = this.gridApi.getSelectedRows()
            var selectedRowsString = ''
            selectedRows.forEach(function(selectedRow, index) {
                if (index !== 0) {
                selectedRowsString += ', '
                }
                selectedRowsString += selectedRow.id
            })
            this.selectedId = selectedRowsString
        },
        refreshData() {
            this.fetchData()
        },
        fetchData() {
            this.isLoading = true
            Promise.all([this.$http.post('outbound/returndeliveryorder?page=' + this.currentPage, this.filter)])
            .then(this.$http.spread((resp) => {
                this.rdo = resp.data.data
                this.totalPage = resp.data.last_page
                this.currentPage = this.currentPage
                this.dataTotal = resp.data.total
                this.dataFrom = resp.data.from ? resp.data.from : 0
                this.dataTo = resp.data.to ? resp.data.to : 0
                this.isLoading = false
            }))
            .catch(() => {
                this.isLoading = false
                this.$vs.dialog({
                    type: 'confirm',
                    color: 'danger',
                    title: 'Server Error',
                    text: 'Try again?',
                    accept: () => {
                        this.refreshData()
                    },
                    acceptText: 'Yes',
                    cancelText: 'No'
                });
            })
        },
        searchDO() {
            this.doSearchError = ''
            this.activeSearchDO = false
            if(this.data.withReference) {
                if(!this.data.do_reference || !this.data.client) {
                    this.doSearchError = 'Please fill all required fields'
                    this.activeSearchDO = true
                    return false
                }
                else {
                    const data = {
                        client_id: this.data.client.id,
                        reference: this.data.do_reference
                    }
                    this.isLoading = true
                    this.$http.post('outbound/returndeliveryorder/checkdo', data)
                    .then(res => {
                        this.isLoading = false
                        this.$router.push({
                            name: 'return-delivery-order-add',
                            params: {
                                id: res.data.do_id,
                                withReference: true
                            }
                        })
                    })
                    .catch(error => {
                        this.isLoading = false
                        const message = error.response.data.message ? error.response.data.message : 'Something went wrong.'
                        this.doSearchError = message
                        this.activeSearchDO = true
                    })
                }
            }
            else {
                this.isLoading = true
                setTimeout(() => {
                    this.isLoading = false
                    this.$router.push({
                        name: 'return-delivery-order-add',
                        params: {
                            withReference: false
                        }
                    })
                }, 200)
            }
        },
        filterData() {
            this.filter.active = false
            this.fetchData()
        },
        deleteData() {
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: 'Confirmation',
                text: 'Are you sure want to delete this data?',
                accept: () => handler()
            })

            const handler = () => {
                this.isLoading = true
                this.$http.delete('outbound/returndeliveryorder/' + this.selectedId + '/destroy')
                .then(res => {
                    this.$vs.notify({
                        color: 'success',
                        title: 'Success',
                        iconPack: 'feather',
                        icon:'icon-check',
                        text: 'Data deleted.'
                    })
                    this.fetchData()
                })
                .catch(error => this.handleError(error))
            }
        },
        viewData() {
            this.$router.push({
                name: 'return-delivery-order-view',
                params: {
                    id: this.selectedId
                }
            })
        },
        fetchDropdowns() {
            this.isLoading = false
            return Promise.all([
                this.$http.post('master/clients'),
                this.$http.post('master/customers')
            ])
            .then(this.$http.spread((clients, customers) => {
                this.client.data = clients.data.data
                this.customer.data = customers.data.data
                this.fetchData()
            }))
            .catch(error => {
                this.isLoading = false
                this.$vs.dialog({
                    type: 'confirm',
                    color: 'danger',
                    title: 'Server Error',
                    text: 'Try again?',
                    accept: () => {
                        this.fetchDropdowns()
                    },
                    acceptText: 'Yes',
                    cancelText: 'No'
                });
            })
        },
        resetFilter() {
            this.filter.reference = ''
            this.filter.id = ''
            this.filter.client_id = null
            this.filter.origin_id = null
            this.filter.destination_id = null
            this.filter.do_reference = ''
            this.filter.rdo_status = 'Open'
        },
    },
    mounted() {
        this.fetchDropdowns()
        this.gridApi = this.gridOptions.api
    },
    beforeMount() {
        this.columnDefs = [
            {
                headerName: 'ID',
                field: 'id',
                width: 120,
            },
            {
                headerName: 'Client ID',
                field: 'client_code',
                width: 120,
            },
            {
                headerName: 'Reference',
                width: 120,
                field: 'reference',
            },
            {
                headerName: 'Req. Del. Date',
                field: 'req_del_date',
                width: 120,
            },
            {
                headerName: 'Origin Name',
                field: 'origin_name',
                width: 120,
            },
            {
                headerName: 'Destination Name',
                field: 'destination_name',
                width: 120,
            },
            {
                headerName: 'DO Reference',
                field: 'do_reference',
                width: 120,
            },
            {
                headerName: 'RDO Status',
                field: 'status',
                width: 120,
            },
        ];

        this.gridOptions.getRowHeight = function(params) {
            return 35;
        }
    }
}

</script>